var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShadowDoping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0064 0.232422H9.9936L0 18.2221L9.9936 36.1853H30.0064L40 18.2221L30.0064 0.232422Z",
    fill: "url(#paint0_radial_11888_14501)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3633 1.52734H10.6372L1.25024 18.3927L10.6372 35.2332H29.3633L38.7502 18.3927L29.3633 1.52734Z",
    fill: "url(#paint1_radial_11888_14501)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0017 0.232422H10.0006L0 18.2089L6 29.2713C6.37785 28.7515 7.0533 28.2205 7.50673 27.7528L2 18.2089L11.0586 2.1035H28.9689L29.7498 3.48081C30.1276 2.88311 30.4803 2.31139 30.833 1.71369L30.0017 0.232422Z",
    fill: "#D8D8D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9795 7.67188C33.6268 8.26958 33.2741 8.86728 32.8963 9.49097L38.0001 18.2049L28.9666 34.3606H13.8272C13.3738 34.9843 12.8952 35.608 12.3914 36.2317H29.9994L40.0001 18.2049L33.9795 7.67188Z",
    fill: "#D8D8D8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11888_14501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.002 18.2119) scale(18.714 19.4274)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1704,
    stopColor: "#182753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8438,
    stopColor: "#0E192D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8665,
    stopColor: "#0E1A2F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11888_14501",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8679 17.4186) scale(17.9033 18.5977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1429,
    stopColor: "#4AEFFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2072,
    stopColor: "#4AE6FF",
    stopOpacity: 0.7272
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4062,
    stopColor: "#4ACFFF",
    stopOpacity: 0.5018
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5949,
    stopColor: "#4AC2FF",
    stopOpacity: 0.2882
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7612,
    stopColor: "#4ABDFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ABDFF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowDoping);
export default __webpack_public_path__ + "static/media/shadow_doping.550b2152b8fc425858bdf244af479096.svg";
export { ForwardRef as ReactComponent };